<p-toast position="top-right"></p-toast>
<div class="employees-Listing-Responsive p-g">
   <div class="p-g-12">
      <div class="card card-w-title p-table-tecfolk-fix">
         <div class="p-g">
            <div class="p-g-6">
               <h1 class="main-Heading">{{setLabel("employeesLabel")}}</h1>
            </div>
            <div class="p-g-6">
            </div>
         </div>
         <div>
            <p-table [value]="employees" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
               [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left;">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByEmployee")}}</span>
                           <input id="searchEmployee" #searchEmployee (keyup)="searchLocal(employee.name, 'name')"
                              [(ngModel)]="employee.name" autocomplete="off" pinputtext=""
                              [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">
                           <span [pTooltip]='setLabel("clearSearchTooltipLabel")' [disabled]="loading" (click)="clear()"> <i
                                   class="pi pi-times"></i></span>
                       </div>
                     </div>
                     <div class="reportMainBtn">
                        <span [pTooltip]='setLabel("clearSearchTooltipLabel")' class="iconClear hideOnLaptop" [disabled]="loading" (click)="clear()"> <i
                           class="pi pi-times"></i></span>

                        <!-- <button (click)="clear()" class="clear-Btn p-button p-widget p-state-default p-corner-all"><i
                              class="fa fa-eraser"></i>&nbsp;Clear
                           Search
                        </button> -->
                        <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="left" (click)="newEmployeeDialog = true" class="iconClear "
                        [disabled]="loading"> <i class="pi pi-user-plus"></i></span>

                        <!-- <button (click)="newEmployeeDialog = true"
                           class="add-New p-button p-widget p-state-default p-corner-all">
                           <i class="fa fa-plus"></i>&nbsp;Add New
                        </button> -->
                     </div>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th class="th-Heading1">{{setLabel("employeeNumberLabel")}}</th>
                     <th class="th-Heading1">{{setLabel("nameLabel")}}</th>
                     <th class="th-Heading1">{{setLabel("imageLabel")}}</th>
                     <th class="th-Heading2">{{setLabel("mobileLabel")}}</th>
                     <th class="th-Heading2">{{setLabel("designationLabel")}}</th>
                     <th class="th-Heading3">{{setLabel("actionLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr class="tr-Main">
                     <td>
                        <div class="mobile-Lable">{{setLabel("employeeCodeLabel")}}</div>
                        {{rowData.employeeCode}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>
                        {{rowData.name}}
                     </td>
                     <td>
                        <div style="display: flex; align-items: center;" class="mobile-Lable">{{setLabel("imageLabel")}}</div>
                        <a (click)="openPhoto(rowData.profile, rowData.gender)">
                           <img class="img" [alt]="" [src]=" rowData.profile
                           ? config.Server + config.employeeImagePath + rowData.profile
                           : rowData.gender && rowData.gender == 'F'
                           ? 'assets/layout/images/avatarGirlImage.png'
                           : 'assets/layout/images/avatarBoyImage.png'" (click)="viewMember(member)"
                              onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="60"
                              style="vertical-align: middle; " />
                        </a>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("mobileLabel")}}</div>
                        {{rowData.phone}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("designationLabel")}}</div>
                        {{getDesignationTitle(rowData.designation)}}
                     </td>
                     <!-- <td>{{rowData.createdOn | date: 'medium'}}</td> -->
                     <td class="td-Button">
                        <div class="action-Btn">{{setLabel("actionLabel")}}</div>
                        <button pButton type="button" [pTooltip]='setLabel("deactivateEmployeeTooltipLabel")' tooltipPosition="top"
                           class="Deactivate-Employee p-button-danger p-button-danger p-button" icon="fa fa-times"
                           (click)="deleteEmployee(rowData)">
                        </button>
                        <button class="Edit-Employee" pButton type="button" [pTooltip]='setLabel("editEmployeeDetailsTooltipLabel")'
                           tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewEmployee(rowData)">
                        </button>
                     </td>
                  </tr>
               </ng-template>
               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div>

      <div class="img-Preview" *ngIf="imgPreview" (click)="closePhotoPreview()">
         <svg (click)="closePhotoPreview()" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
            class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
            <path fill="currentColor"
               d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
            </path>
         </svg>
         <img [src]="imgPreviewImg
            ? config.Server + config.employeeImagePath +imgPreviewImg
            : 'assets/layout/images/avatarBoyImage.png'" (click)="viewMember(member)"
            onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
            style="width: 25vw; height: auto;background: #fff;" />
      </div>
   </div>
</div>

<p-dialog [(visible)]="newEmployeeDialog" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '47vw', left:'5%', top:'10px'}">
   <p-header>
      {{setLabel("createEmployeeLabel")}}
   </p-header>
   <form #newEmployeeForm="ngForm">
      <div class="Create-Employee p-g-12">
         <button routerLink="/employee" class="create-New-Btn p-button p-widget p-state-default p-corner-all">
            <i class="fa fa-plus" style="margin-right: 8px;"></i> {{setLabel("createAsNewEmployeeBtnLabel")}}
         </button>

         <button (click)="existingUsersDialog = true ; newEmployeeDialog = false; focusUserSearchInput()"
            class="create-Existing-Btn p-button p-widget p-state-default p-corner-all">
            <i class="fa fa-plus" style="margin-right: 8px;"></i> {{setLabel("createAsExistingUserBtnLabel")}}
         </button>

         <!-- <button (click)="existingTrainersDialog = true ; newEmployeeDialog = false; focusTrainerSearchInput()"
            style="background: #ad7000; color: white; margin-right: 8px; height: 5vh;"
            class="p-button p-widget p-state-default p-corner-all">
            <i class="fa fa-plus" style="margin-right: 8px;"></i> Create As Existing Trainer
         </button> -->
      </div>
   </form>
</p-dialog>

<p-dialog [(visible)]="existingUsersDialog" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '55vw', left:'5%', top:'10px'}">
   <p-header>
      {{setLabel("existingUsersLabel")}}
   </p-header>
   <form>
      <div class="p-g-12 p-table-tecfolk-fix">

         <p-table [value]="users" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
            [first]="firstOfUserTable" (onPage)="onPageChangeUsersTable($event)">

            <ng-template pTemplate="caption" style="text-align: left">

               <div style="display: flex; flex-direction: column; gap: 10px;" class="existing-Users-Search-Main">
                  <input id="searchUser" #searchUser autocomplete="off" pinputtext="" [placeholder]='setLabel("searchByUserNamePlaceholderLabel")'
                     type="text" name="name" class="searchUser ng-pristine ng-valid ng-touched"
                     (keyup)="searchLocalUsers(userObject.name, 'name')" [(ngModel)]="userObject.name">

                  <button (click)="clearUserSearchField()"
                     class="Clear-Search-btn p-button p-widget p-state-default p-corner-all"><i
                        class="fa fa-eraser"></i>&nbsp;{{setLabel("clearSearchBtnLabel")}}
                  </button>
               </div>

            </ng-template>


            <ng-template pTemplate="header">
               <tr>
                  <th class="th-Heading1">{{setLabel("nameLabel")}}</th>
                  <th class="th-Heading1">{{setLabel("photoLabel")}}</th>
                  <th class="th-Heading2">{{setLabel("emailLabel")}}</th>
                  <th class="th-Heading3">{{setLabel("actionLabel")}}</th>
               </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
               <tr>
                  <td>{{rowData.name}}</td>
                  <td>
                     <a (click)="openPhoto(rowData.profile, rowData.gender)">
                        <img [alt]="" src="{{config.Server + config.employeeImagePath + rowData.profile}}" width="60"
                           style="vertical-align: middle" />
                     </a>
                  </td>
                  <!-- <td>{{rowData.userRole.name}}</td> -->
                  <td>
                     <div style="line-break: anywhere;">

                        {{rowData.email}}
                     </div>

                  </td>
                  <!-- <td>{{rowData.phone}}</td> -->
                  <!-- <td>{{rowData.phone}}</td> -->
                  <td style="text-align: justify;" class="td-Button">
                     <button pButton type="button" [pTooltip]='setLabel("selectUserAsemployeeTooltipLabel")' tooltipPosition="top"
                        icon="fa fa-plus" style="margin-right: 5px;" (click)="selectUserAsEmployee(rowData)">
                     </button>
                  </td>
               </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
               <tr style="color: black;">
                  <td>
                     {{setLabel("noRecordFoundLabel")}}
                  </td>
               </tr>
            </ng-template>

         </p-table>

      </div>
   </form>
</p-dialog>

<p-dialog [(visible)]="existingTrainersDialog" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '55vw', left:'5%', top:'10px'}">
   <p-header>
      {{setLabel("existingTrainersLabel")}}
   </p-header>
   <form>
      <div class="p-g-12 p-table-tecfolk-fix">

         <p-table [value]="trainers" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
            [first]="firstOfTrainerTable" (onPage)="onPageChangeTrainersTable($event)">

            <ng-template pTemplate="caption" style="text-align: left">
               <input id="searchTrainer" #searchTrainer autocomplete="off" pinputtext=""
               [placeholder]='setLabel("searchByUserNamePlaceholderLabel")' type="text" name="name"
                  class="Search-Trainer-Name ng-pristine ng-valid ng-touched"
                  (keyup)="searchLocalTrainers(trainer.name, 'name')" [(ngModel)]="trainer.name">

               <button style="background: #ffffff; color: #0e2031; margin-right: 8px;"
                  (click)="clearTrainersSearchField()" class="p-button p-widget p-state-default p-corner-all"><i
                     class="fa fa-eraser"></i>&nbsp;Clear Search
               </button>
            </ng-template>


            <ng-template pTemplate="header">
               <tr>
                  <th class="th-Heading1">{{setLabel("nameLabel")}}</th>
                  <th class="th-Heading1">{{setLabel("photoLabel")}}</th>
                  <!-- <th style="max-width: 90px;">Role</th> -->
                  <!-- <th style="max-width: 130px;">Email</th> -->
                  <th class="th-Heading2">{{setLabel("phoneLabel")}}</th>
                  <!-- <th style="max-width: 130px;">Branch</th> -->
                  <th class="th-Heading3">{{setLabel("actionLabel")}}</th>
               </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
               <tr>
                  <td>{{rowData.name}}</td>
                  <td>
                     <a (click)="openPhoto(rowData.profile, rowData.gender)">
                        <img class="img" [alt]="" [src]=" rowData.profile
                        ? config.Server + config.employeeImagePath + rowData.profile
                        : rowData.gender && rowData.gender == 'F'
                        ? 'assets/layout/images/avatarGirlImage.png'
                        : 'assets/layout/images/avatarBoyImage.png'" (click)="viewMember(member)"
                           onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="60"
                           style="vertical-align: middle; " />
                     </a>
                  </td>
                  <!-- <td>{{rowData.userRole.name}}</td> -->
                  <!-- <td>{{rowData.email}}</td> -->
                  <td>{{rowData.contact}}</td>
                  <!-- <td>{{rowData.phone}}</td> -->
                  <td class="td-Button">
                     <button pButton type="button" [pTooltip]='setLabel("selectTrainerAsemployeeTooltipLabel")' tooltipPosition="top"
                        icon="fa fa-pencil-square-o" style="margin-right: 5px;"
                        (click)="selectTrainerAsEmployee(rowData)">
                     </button>
                  </td>
               </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
               <tr style="color: black;">
                  <td>
                     {{setLabel("noRecordFoundLabel")}}
                  </td>
               </tr>
            </ng-template>

         </p-table>

      </div>
   </form>
</p-dialog>